import { Api } from '@common/services/api';

import type { User } from '@common/types/objects';
import type { Pagination } from '@common/components/list';
import type { APIResponsePrivateMessage } from '../types/objects';

export type APIResponseFetchMessages = {
  data: APIResponsePrivateMessage[];
  meta: {
    pagination: Pagination;
    related: {
      users: User[];
    };
  };
};

export const fetchMessages = async ({
  organisationId,
  conversationId,
  cursor,
  messageId,
  before_limit = 20,
  after_limit = 20,
  signal,
}: {
  organisationId: string;
  conversationId: string;
  cursor?: string | boolean | null;
  messageId?: string;
  before_limit?: number;
  after_limit?: number;
  signal?: AbortSignal;
}) => {

  let baseUrl = `/v3/organisations/${organisationId}/conversations/${conversationId}/messages?${Api.utils.toQuery({ cursor })}`;

  if (messageId) {
    const queryParams = Api.utils.toQuery({ before_limit, after_limit });
    baseUrl = `/v3/organisations/${organisationId}/conversations/${conversationId}/messages/${messageId}/context?${queryParams}`;
  }

  const request = await Api.get<APIResponseFetchMessages>(baseUrl, true, {
    ...(signal && { signal }),
  });
  return request;
};
